export default class Airport {
  id: string = '';
  name: string = '';
  iataCode: string = '';

  constructor(data: Partial<Airport> = {}) {
    Object.assign(this, data);
  }

  clone(): Airport {
    return new Airport(this);
  }
}